// @flow

import React from 'react';
import { connect }          from 'react-redux';
import './index.css';
import './responsive.css';
import Routes    from './routes';
import Header    from './header/header';
import Footer    from './footer/footer';

const Session = () => {
  return (
    <div className="session">
      <Header />
      <div id="wrapper">
        <Routes />
      </div>
      <Footer />
    </div>
  );
}

export default connect()(Session);



// WEBPACK FOOTER //
// ./src/components/session/index.js